import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormulaireFiserv } from '../../models/formulaire/formulaire-fiserv.model';

@Injectable({ providedIn: 'root' })
export class FormulaireFiservService {
  formGroup: FormGroup<FormulaireFiserv> | null = null;

  setForm(form: FormGroup<FormulaireFiserv>) {
    this.formGroup = form;
  }

  getForm(): FormGroup<FormulaireFiserv> | null {
    return this.formGroup;
  }
}
